import {
  INCREMENT_ROOM_UNREAD,
  LOGOUT,
  RESET_ROOM_UNREAD,
  RESET_UNSEEN_MESSAGE_COUNT,
  SET_CHAT_RECEIVER_DETAILS,
  SET_JOB_MEMBERS_PROFILE,
  SET_UNSEEN_MESSAGE_COUNT,
} from "../actions/action.types";
import { matchesConversationRoom } from "../../utils/chatConversation";

const initialState = {
  unseenCount: 0,
  membersProfile: [],
  chatReceiverDetails: null,
};

// Recompute a profile's totalUnread from the viewer's per-room unread counts,
// so the contact-card badge and the derived global count never drift.
const recomputeTotalUnread = (profile, userId) => ({
  ...profile,
  totalUnread: (profile?.recentRooms || []).reduce(
    (sum, room) => sum + (Number(room?.unreadCounts?.[userId]) || 0),
    0,
  ),
});

// Apply a per-room unread mutation to the profile that owns `jobId`.
const mutateRoomUnread = (membersProfile, jobId, userId, nextCount, participantId) =>
  (membersProfile || []).map((profile) => {
    const ownsRoom = (profile?.recentRooms || []).some(
      (room) => matchesConversationRoom(profile, room, jobId, participantId),
    );
    if (!ownsRoom) return profile;

    const recentRooms = profile.recentRooms.map((room) => {
      if (!matchesConversationRoom(profile, room, jobId, participantId)) return room;
      const current = Math.max(0, Number(room?.unreadCounts?.[userId]) || 0);
      return {
        ...room,
        unreadCounts: {
          ...room?.unreadCounts,
          [userId]: nextCount(current),
        },
      };
    });
    return recomputeTotalUnread({ ...profile, recentRooms }, userId);
  });

const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNSEEN_MESSAGE_COUNT:
      return {
        ...state,
        unseenCount: action.payload,
      };
    case SET_JOB_MEMBERS_PROFILE:
      return {
        ...state,
        membersProfile: action.payload,
      };
    case SET_CHAT_RECEIVER_DETAILS:
      return {
        ...state,
        chatReceiverDetails: action.payload,
      };
    case INCREMENT_ROOM_UNREAD:
      return {
        ...state,
        membersProfile: mutateRoomUnread(
          state.membersProfile,
          action.payload?.jobId,
          action.payload?.userId,
          (current) => current + 1,
          action.payload?.participantId,
        ),
      };
    case RESET_ROOM_UNREAD:
      return {
        ...state,
        membersProfile: mutateRoomUnread(
          state.membersProfile,
          action.payload?.jobId,
          action.payload?.userId,
          () => 0,
          action.payload?.participantId,
        ),
      };
    case RESET_UNSEEN_MESSAGE_COUNT:
      return {
        ...state,
        unseenCount: 0,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default messageReducer;
